// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { spacing } from "@recidiviz/design-system";
import { rem } from "polished";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Button, Icon } from "~design-system";

/**
 * Rather than linking to an explicit URL, this button simply navigates
 * to the previous entry in the React Router history stack.
 */
export function HistoryBackButton({
  children = "Back",
}: {
  children?: React.ReactNode;
}) {
  const navigate = useNavigate();

  return (
    <Button onClick={() => navigate(-1)} role="link">
      <Icon
        kind="Arrow"
        size={12}
        rotate={180}
        style={{ marginRight: rem(spacing.xs) }}
      />
      {children}
    </Button>
  );
}
